class BrandsSection extends HTMLElement{
    connectedCallback(){
        if (!this.isConnected) return;
        
        this.buttons = Array.from(this.querySelectorAll('[data-navigation-item]'));
        this.listItems = Array.from(this.querySelectorAll('[data-list-item]'));
        this.listenNavigationItemClick();
    }

    listenNavigationItemClick(){
        const navContainer = this.querySelector('[data-navigation-content]');
        if(!navContainer) return;

        navContainer.addEventListener('click', (e) => {
            let target = null;

            if(e.target.tagName === 'BUTTON') target = e.target;
            else if(e.target.parentNode.tagName === 'BUTTON') target = e.target.parentNode;
            else return;

            this.setActiveButton(target);
        });
    }

    setActiveButton(button){
        this.buttons.forEach((btn) => btn.classList.remove('active'));
        button.classList.add('active');
        this.activeLetter = button.dataset.value;


        if(!document.startViewTransition){
            this.toggleElements();
            return;
        }

        document.startViewTransition(() => this.toggleElements());
    }

    toggleElements(){
        if(!this.activeLetter) return;

        this.listItems.forEach((item) => {
            const name = item.dataset.name;

            const firstLetter = name.charAt(0).toLowerCase();
            const letterMatches = this.activeLetter.toLowerCase() === firstLetter;

            if(this.activeLetter === 'all' || letterMatches){
                this.showItem(item);
            }
            else{
                this.hideItem(item);
            }
        })
    }

    hideItem(item){
        item.classList.add('hidden');
        item.setAttribute('aria-hidden', 'true');
    }

    showItem(item){
        item.classList.remove('hidden');
        item.setAttribute('aria-hidden', 'false');
    }
}

if(!customElements.get('brands-section')){
    customElements.define('brands-section', BrandsSection);
}